/**
 * Created by Kirill Mashchenko on 22.07.19.
 */

/**
 * @class Layer for aquarius robot settings.
 * @extends PlayerRobotSettingsLayer
 * @constructor
 * @param {pm.AbstractRobot} robot Robot which settings need to display.
 */
var AquariusRobotSettingsLayer = PlayerRobotSettingsLayer.extend(/** @lends AquariusRobotSettingsLayer# */{

	ctor: function(robot)
	{
		this._super(robot);

		this._label.setString(LocalizedString("Aquarius") + " " + robot.id + ", " + LocalizedString("Pattern") + " " + robot.parentLevel.programData[robot.groupID].currentIndex);
	}
});
